import React, { useEffect, useState } from "react";
import "./SearchBar.css";

const SearchBar = ({
  categories = [],
  activeCategory,
  onChangeCategory,
  searchTerm,
  onSearchChange,
  onSearchSubmit,
  isSearchMode,
  onReset,
}) => {
  const [showFilters, setShowFilters] = useState(false);

  const pushToDataLayer = (event, keyword) => {
    // Post to parent window for GTM tracking (when embedded in iframe)
    window.parent.postMessage({
      type: "DATALAYER_PUSH",
      event,
      data: { keyword }
    }, "*");
  };

  const handleCategoryClick = (categoryName) => {
    pushToDataLayer("category_pill_click", categoryName);
    onChangeCategory(categoryName);
  };

  const handleSearchSubmit = (term) => {
    if (term) {
      pushToDataLayer("search_performed", term);
    }
    onSearchSubmit?.(term);
  };

  useEffect(() => {
    const icons = document.querySelectorAll(".category-pill img");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    icons.forEach((icon) => observer.observe(icon));
  }, []);

  return (
    <section className="podcast-search-wrapper">
      <div className="category-search-bar-row">
        {/* Mobile: Search + Filter Button */}
        <div className="mobile-search-row">
          <input
            type="text"
            placeholder="Search experts by keyword..."
            className="category-search-input mobile-search-input"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearchSubmit(e.currentTarget.value);
              }
            }}
          />
          <button
            className="filter-toggle-button"
            onClick={() => setShowFilters(!showFilters)}
            aria-label="Toggle filters"
          >
            <img
              src={showFilters
                ? "https://www.qwoted.com/wp-content/uploads/2025/10/filter.png"
                : "https://www.qwoted.com/wp-content/uploads/2025/10/filter-inactive.png"
              }
              alt="Filter"
            />
          </button>
        </div>

        {/* Category Pills */}
        <div className={`category-scroll-container ${showFilters ? "show-mobile" : ""}`}>
          {categories.map((cat) => (
            <button
              key={cat.name}
              className={`category-pill ${activeCategory === cat.name ? "active" : ""}`}
              onClick={() => handleCategoryClick(cat.name)}
            >
              {cat.name !== "All" && <img src={cat.icon} alt={`${cat.name} icon`} />}
              <span>{cat.name}</span>
            </button>
          ))}
        </div>

        {/* Desktop Search Input + Buttons */}
        <div className="search-bar-container desktop-search">
          <input
            type="text"
            placeholder="Search experts by keyword..."
            className="category-search-input"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearchSubmit(e.currentTarget.value);
              }
            }}
          />
          <button
            className="search-button"
            onClick={() => handleSearchSubmit(searchTerm)}
          >
            Search
          </button>
          {isSearchMode && (
            <button className="reset-search" onClick={onReset}>
              Reset
            </button>
          )}
        </div>

        {/* Mobile Search Button (below filters when shown) */}
        <div className="mobile-search-actions">
          <button
            className="search-button mobile-search-button"
            onClick={() => handleSearchSubmit(searchTerm)}
          >
            Search
          </button>
          {isSearchMode && (
            <button className="reset-search" onClick={onReset}>
              Reset
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default SearchBar;
